import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Salutations } from '@markant-platform/shared/data-access';
import { MarkantSelectOption } from '@markant-platform/shared/util-helpers';
import { TrackingService } from '@markant-platform/shared/util-tracking';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MarkantElementsModule } from '@markant/elements-angular';
import { FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'markant-platform-registration-user',
  templateUrl: './registration-user.component.html',
  styleUrls: ['../registration.scss'],
  imports: [
    MarkantElementsModule,
    ReactiveFormsModule,
    FormControlKeyErrorPipe,
    TranslocoPipe,
    FormControlErrorPipe,
    NgIf,
  ],
})
export class RegistrationUserComponent {
  @Input() userForm!: FormGroup;
  @Input() outlined = false;
  @Input() showError?: boolean;
  @Input() analyticsRegistrationEventName?: string;
  @Input() analyticsRegistrationStepName?: string;

  protected readonly pathToTranslation = 'register.user.';
  protected salutationOptions: MarkantSelectOption[] = this.getSalutationOptions();

  constructor(
    private readonly trackingService: TrackingService,
    private readonly translocoService: TranslocoService
  ) {
    this.translocoService.langChanges$.pipe(takeUntilDestroyed()).subscribe(() => {
      this.salutationOptions = this.getSalutationOptions();
    });
  }

  private getSalutationOptions(): MarkantSelectOption[] {
    return Salutations.map(salutation => ({
      value: salutation.value,
      representation: this.translocoService.translate(salutation.translationKey),
    }));
  }

  pushVisitInputFieldEventToDataLayer(inputFieldName: string): void {
    this.trackingService.pushFocusInputFieldEventToDataLayer(
      this.analyticsRegistrationEventName || '',
      this.analyticsRegistrationStepName || '',
      inputFieldName
    );
  }
}
